<template>
	<div class="tabBarView">
		<topfixed v-show='topfixedShow'></topfixed>
		<iframe v-show="iframeState" id="show-iframe" frameborder=0 name="showHere" scrolling=auto src=""></iframe>
		<nav class="bar-tab clearfix">
			<router-link  :number = "1" :class="[bnumber==1 ? 'tab-item active' :'tab-item']"  to="homePage"  @click.native="tabclick($event)">
				<span :number="1" class="icon icon-logo"></span>
				<span :number="1" class="tab-label">首页</span>
			</router-link>
			<router-link :number="2" :class="[bnumber==2 ? 'tab-item active' :'tab-item']" to="/companyDynamics" @click.native="tabclick($event)">
				<span :number="2" class="icon icon-megaphone"></span>
				<span :number="2" class="tab-label">公司动态</span>
			</router-link>
			<router-link :number="3" :class="[bnumber==3 ? 'tab-item active' :'tab-item']" to="/caseResults" @click.native="tabclick($event)">
				<span :number="3" class="icon icon-book2"></span>
				<span :number="3" class="tab-label">案例成果</span>
			</router-link>
			<router-link :number="4" :class="[bnumber==4 ? 'tab-item active' :'tab-item']" to="/demoSystem"  @click.native="tabclick($event)">
				<span :number="4" class="icon icon-movie_filter"></span>
				<span :number="4" class="tab-label">演示系统</span>
			</router-link>
			 <!-- <div :number="4" :class="[bnumber==4 ? 'tab-item active' :'tab-item']"  >
				<a target="showHere" :href="link" :number="4" @click="showIframe" class="icon icon-movie_filter"></a>
				<a target="showHere" :href="link" :number="4" @click="showIframe" class="tab-label">旅游行业知识库</a> -->
				<!--<span :number="4" @click="test" class="icon icon-movie_filter"></span>
				<span :number="4" @click="test" class="tab-label">旅游行业知识库</span>
				<span :number="4" class="tab-label">演示系统</span>
			</div> -->
			<router-link :number="5" :class="[bnumber==5 ? 'tab-item active' :'tab-item']" to="/brandCenter" @click.native="tabclick($event)">
				<span :number="5" class="icon icon-award"></span>
				<span :number="5" class="tab-label">品牌中心</span>
			</router-link>
		</nav>
		
	</div>
</template>

<script>
	import topfixed from '../components/topfixed'
	import config from '../assets/js/config.js'
	export default {
		name: 'navHeader',
		components:{
			topfixed
		},
		data() {
			return {
				link:'http://lib.citgroup.cn/m',
				iframeState:false,
				topfixedShow:true,
				bnumber: 1
			}
		},
		mounted() {
			this.arguments();
			const oIframe = document.getElementById('show-iframe');
    		const deviceWidth = document.documentElement.clientWidth;
    		const deviceHeight = document.documentElement.clientHeight;
    		oIframe.style.width = deviceWidth + 'px';
    		oIframe.style.height = deviceHeight + 'px';
		},
		methods: {
//			homePage(){
//				this.$router.push({ path: '/homePage' })
//			},
			test() {
//				window.location.href = 'http://lib.citgroup.cn/m'
			},
			showIframe(){
				this.topfixedShow=false;
      			this.goBackState = true;
      			this.iframeState = true;
   			},
			tabclick(ev) {
				this.$nextTick(function () {
//					if(ev.currentTarget)
					this.bnumber = ev.target.attributes.number.nodeValue;
					console.log(this.bnumber);
					if(this.bnumber==2){
						this.topfixedShow=false;
					}
				})
				this.iframeState=false;
				this.topfixedShow=true;
			},
			arguments() {
				var that = this;
				that.$ajax.get(config.homePage.msgList)
					.then(function(response) {
						console.log(response.data)

					})
			}
		}
	}
</script>

<style scoped>
	.bar-tab {
		height: 1rem;
		background: #fff;
		width: 100%;
		position: fixed;
		bottom: 0;
		left: 0;
		border-top: 1px solid #999;
		z-index: 9;
		display: flex;
		display: -webkit-flex;
		justify-content: space-between;
		align-items: center;
	}
	
	.tab-item {
		/*width: 20%;*/
		text-align: center;
		/*float: left;*/
		/*color: red;*/
		
	}
	
	.icon {
		display: block;
		font-size: .3rem;
		margin: .25rem 0 .13rem 0;
		line-height: .18rem;
		color: #656565
	}
	
	.tabBarView .tab-label {
		font-size: .2rem
	}
	/* .icon-megaphone,.icon-movie_filter,.icon-award,.icon-book2{margin-bottom:.03rem} */
	
	.active .icon-logo:before {
		color: #000
	}
	
	.active .icon-megaphone:before {
		color: #000
	}
	
	.active .icon-book2:before {
		color: #000
	}
	
	.active .icon-award:before {
		color: #000
	}
	
	.active .icon-movie_filter:before,
	.active .tab-label {
		color: #000
	}
</style>


// WEBPACK FOOTER //
// src/components/navHeader.vue